<div class="container">
    <div class="row">
        <div class="col-lg-4 col-md-12 col-sm-12">

            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <mat-card-title>Minimal Konfiguration</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <img mat-card-image class="example-image"
                        src="../../../../../../assets//undraw/undraw_file_analysis.svg">
                    <p>
                        Die schnellste Möglichkeit neue Aktionen zu erstellen und zu veröffentlichen
                    </p>
                </mat-card-content>
                <mat-card-actions align="end">
                    <button mat-button color="accent" [routerLink]="['add', typeminimal]">Starten</button>
                </mat-card-actions>
            </mat-card>
        </div>
        <div class="col-lg-4 col-md-12 col-sm-12">

            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <mat-card-title>Experten Konfiguration</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <img mat-card-image class="example-image"
                        src="../../../../../../assets/undraw/undraw_confirmation.svg">
                    <p>
                        Die umfangreiche Konfiguration von Aktionen inklusive Begrenzung nach Haushalten und Tagen
                    </p>
                </mat-card-content>
                <mat-card-actions align="end">
                    <button mat-button color="accent" [routerLink]="['add', typeadvancted]">Starten</button>
                </mat-card-actions>
            </mat-card>
        </div>
        <div class="col-lg-4 col-md-12 col-sm-12">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <mat-card-title>Gewinnspiel</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <img mat-card-image class="example-image"
                        src="../../../../../../assets/undraw/undraw_join_re_w1lh.svg">
                    <p>
                        Erstellen Sie ein Gewinnspiel und ziehen sie anschließend eine Anzahl von Gewinnern
                    </p>
                </mat-card-content>
                <mat-card-actions align="end">
                    <button mat-button color="accent" [routerLink]="['add', typeadvancted]">Starten</button>
                </mat-card-actions>
            </mat-card>
        </div>
    </div>

</div>